import { Component, Input } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ProductsServices } from '../../services';

@Component({
    selector: 'page-product-create-partial-description',
    templateUrl: 'product-create-partial-description.html',
})
export class ProductCreatePartialDescriptionPage {
    @Input() update_state;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public http: HttpClient,
        public alertCtrl: AlertController,
        public productsServices: ProductsServices) {

    }



}



// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-partial-description/product-create-partial-description.ts